var map = {
	"./algorithm.json": 83257,
	"./algorithm_ver3.json": 3780,
	"./allinone0526.json": 98751,
	"./loading.json": 28324,
	"./pdf_loading.json": 76057,
	"./stage_ver3.json": 69201
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 30035;